<template>
  <div
    :id="`panel-${panelSide}`"
    class="lp-index-panel"
    :class="panelClasses"
    :style="panelStyle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PanelWrapper',
  inject: ['lessonPlanController'],
  props: {
    panelSide: {
      type: String,
      required: true,
      validator: val => ['left', 'right'].includes(val)
    },
    leftPanelSelected: {
      type: Number,
      default: -1
    },
    rightPanelSelected: {
      type: Number,
      default: -1
    }
  },
  computed: {
    isLeft() {
      return this.panelSide === 'left';
    },
    selectedIndex() {
      return this.isLeft ? this.leftPanelSelected : this.rightPanelSelected;
    },
    selectedSlide() {
      return this.lessonPlanController.navigation.selectedSlide;
    },
    panelClasses() {
      const isFullscreen = this.lessonPlanController?.isFullscreen;
      return {
		    [`panel-${this.panelSide}`]: true,
        [`${this.panelSide}-panel`]: !isFullscreen,
        [`${this.panelSide}-panel__closed`]: isFullscreen && this.selectedIndex === -1,
        [`${this.panelSide}-panel__openned`]: isFullscreen && this.selectedIndex > -1
      };
    },
    panelWidth() {
      return this.isLeft ? 480 : this.lessonPlanController.rightPanelWidth + this.lessonPlanController.rightPanelBarWidth;
    },
    panelStyle() {
      const width = this.selectedIndex > -1 ? this.panelWidth : 80;
      return {
        width: `${width}px`
      };
    }
  },
  mounted() {
    if (this.isLeft) return;

    const panel = this.getRightPanel();

    this.updatePanelOffset();

    if (!panel) return;

    panel.addEventListener('mouseenter', this.positionPanelWhenShown);
    panel.addEventListener('mouseleave', this.positionPanelWhenHidden);
  },
  methods: {
    getRightPanel() {
      return document.getElementById('panel-right');
    },
    getClosedPanelHoverOffset() {
      return this.lessonPlanController.rightPanelBarWidth - this.lessonPlanController.panelHoverArea;
    },
    getOpenedPanelHoverOffset() {
      return this.panelWidth - this.lessonPlanController.panelHoverArea;
    },
    getCurrentOffset() {
      return this.selectedIndex > -1 ? this.getOpenedPanelHoverOffset() : this.getClosedPanelHoverOffset();
    },
    updatePanelOffset() {
      const panel = this.getRightPanel();

      if (!panel) return;

      const panelOffset = this.getCurrentOffset();

      panel.style.setProperty('--panel-offset', `-${panelOffset}px`);
      panel.style.setProperty('transition', 'none');
    },
    positionPanelWhenShown() {
      const panel = this.getRightPanel();

      if (!panel) return;

      panel.style.setProperty('--panel-offset', '0');
      panel.style.setProperty('transition', 'all 0.2s');
    },
    positionPanelWhenHidden() {
      const panel = this.getRightPanel();

      if (!panel) return;

      const panelOffset = this.getCurrentOffset();

      panel.style.setProperty('--panel-offset', `-${panelOffset}px`);
      panel.style.setProperty('transition', 'all 0.2s');
    }
  },
  watch: {
    selectedSlide: {
      handler() {
        this.updatePanelOffset();
      }
    }
  }
};
</script>
